import styled from 'styled-components';


export const HomeWrapper = styled.div(
  props => `
    width:100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    justify-content: space-between;
    min-height:100vh;
  `,
)

export const PageMainWrapper = styled.section(
  props => `
    width:100%;
    display: flex;
    flex-direction: row;
    height: 100%;
    background-color: #dff0ff;

    @media only screen and (min-width:320px) and (max-width: 767px){
      flex-direction: column;
    }

    @media only screen and (min-width:768px) and (max-width: 1024px){
      flex-direction: column;
      justify-content: space-between;
    }
  `,
);

export const Arc = styled.div(
  props => `
    position: relative;
    overflow: hidden;
    height: 45px;
    position: relative;
    margin-top: -35px;
    // background: #dff0ff;
    background: ${props.theme.colors.white.base};
    // background: transparent;

    // &::after {
    //   position: absolute;
    //   background: #eef4fd;
    //   right: -300px;
    //   left: -300px;
    //   top: 0px;
    //   content: '';
    //   bottom: -200px;
    //   z-index: 1;
    // }

    &::before {
      border: 1px solid #8ebde3;
      border-radius: 100%;
      position: absolute;
      background: #eef4fd;
      // background: transparent;
      right: -300px;
      left: -300px;
      top: -200px;
      content: '';
      bottom: 0;
      z-index: 2;
    }
  `
);
